import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import LocationProfileSearchRequest from '@/models/Locations/LocationProfileSearchRequest';
import LocationSearchViewModel from '@/models/Locations/LocationSearchViewModel';
import WorkerProfileSearchRequest from '@/models/Workers/WorkerProfileSearchRequest';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import LocationSearchOptionsResponse from '@/models/Locations/LocationSearchOptionsResponse';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkType from '@/models/Shared/WorkType';

export interface ILocationListState {
  loading: boolean;
  locations: LocationProfileDto[];
  locationSearchViewModel: LocationSearchViewModel;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'LocationList', namespaced: true})
class LocationList extends VuexModule implements ILocationListState {
  
  public loading = true;
  public locations: LocationProfileDto[] = [];  
  public locationSearchViewModel: LocationSearchViewModel = new LocationSearchViewModel(null, null);
  public loadingDialog = false;


  @Action
  async searchLocations() {
    const request = new LocationProfileSearchRequest();

    if (this.locationSearchViewModel.selectedWorker != null) {
      if (this.locationSearchViewModel.selectedDistance.value != -1) {
        request.distance = this.locationSearchViewModel.selectedDistance.value;
        request.latitude = this.locationSearchViewModel.selectedWorker.latitude;
        request.longitude = this.locationSearchViewModel.selectedWorker.longitude;
      }
    }
    if (this.locationSearchViewModel.selectedLocationTypes.length > 0) {
      request.locationTypeIds = this.locationSearchViewModel.selectedLocationTypes.map(function(locationType) {
        return locationType['id'];
      });
    }

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/locations/search`, request)
    .then(response => {
      this.context.commit("setLocations", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getLocationSearchOptions() {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/locations/search-options`)
    .then(response => {
      this.context.commit("setLocationSearchOptions", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkersForSearchOptions() {
    const request = new WorkerProfileSearchRequest();
    request.statuses.push(WorkerStatus.Active);
    request.workTypes.push(WorkType.Temp, WorkType.Perm);
    //this.setLoading(true);
    await ajax.post(`/api/v1/agency/workers/search`, request)
    .then(response => {
      this.context.commit("setWorkers", response.data);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.loading = true;
    this.locations = [];
    this.locationSearchViewModel = new LocationSearchViewModel(null, null)
    this.loadingDialog = false;
   
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLocations(locations: LocationProfileDto[]) {
      this.locations = locations;
  }

  @Mutation
  private async setWorkers(workers: WorkerProfileDto[]) {
      this.locationSearchViewModel.workers = workers;
  }

  @Mutation
  private async setLocationSearchOptions(options: LocationSearchOptionsResponse) {
    this.locationSearchViewModel = new LocationSearchViewModel(options.locationTypes,  new DistanceViewModel(0, "Unlimited"));
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }
}

export const LocationListModule = getModule(LocationList)
